export const strings = {
  switchTo: 'Switch to',
  toggleModeButtonText: isAdminMode => `${isAdminMode ? 'User' : 'Admin'} mode`,
};
